/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AudioMatrix.vue?vue&type=template&id=400fc5a7&scoped=true&"
import script from "./AudioMatrix.vue?vue&type=script&lang=js&"
export * from "./AudioMatrix.vue?vue&type=script&lang=js&"
import style0 from "./AudioMatrix.vue?vue&type=style&index=0&id=400fc5a7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400fc5a7",
  null
  
)

export default component.exports